import script from "./SplitView.vue?vue&type=script&setup=true&lang=ts"
export * from "./SplitView.vue?vue&type=script&setup=true&lang=ts"

import "./SplitView.vue?vue&type=style&index=0&id=94708654&lang=scss"

const __exports__ = script;

export default __exports__